/**
 * @deprecated Use DateFormatter from '@lib/date-utils' instead
 * This file is kept for backward compatibility during migration
 */
import { DateFormatter } from '../lib/date-utils';

// Re-export DateFormatter as MomentFormatter for backward compatibility
export default DateFormatter;
